import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DashboardExportLogDetails = lazy(() =>
  import("@scenes/ExportLogs/ExportLogDetails/ExportLogDetails").then((module) => ({
    default: module.ExportLogDetails,
  }))
);

export const dashboardExportLogsDetailsNRO: NavigationRoutingObject = {
  Component: DashboardExportLogDetails,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-export-logs-details-nro-heading", "Export Log Details"),
  pageNameForTracking: () => "Export Log Details",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userCanViewReports = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    const userHasPermission = featureOn("reporting_permissions_update") ? userCanViewReports : true;

    return isImpersonating || userHasPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/export_logs/:appGroupId",
  noKnockoutFallback: true,
};
